import React from 'react';
import "./AudioControlsSection.css"
// import { Button, Popover } from '@wwnds/react';
// COMPONENTS
import AudioPlayer from '../AudioPlayer/AudioPlayer';
// import image from '../../assets/composer.jpeg'
// import infoIcon from '../../assets/Info-icon.svg'

const AudioControlsSection = ({
  audRef,
  isPlaying,
  setIsPlaying,
  setCurrentTime,
  currentTime,
  dataLoaded,
  Data,
  timelineIndex,
  formatSectionHeaderStr,
  updateTime,
  formatTime }) => {

  const formatCompositionTitle = (str) => {
    let formattedStr = str.replace(/<em\s*\/?>/gi, '')
    formattedStr = formattedStr.replace(/<\/em\s*\/?>/gi, '')
    formattedStr = formattedStr.replace(/<p\s*\/?>/gi, '')
    formattedStr = formattedStr.replace(/<\/p\s*\/?>/gi, '')
    formattedStr = formattedStr.replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, ' ');
    return (formattedStr)
  }
  const formatCustomText = (str) => {
    if (str) {
      let formattedStr = str.replace(/<p\s*\/?>/gi, '')
      formattedStr = formattedStr.replace(/<\/p\s*\/?>/gi, '')
      return (formattedStr)
    } else {
      return str
    }
  }

  // const [infoIsOpen, setInfoIsOpen] = useState(false);
  // const [infoRef, setInfoRef] = useState();

  return (
    <section className="audio-controls-section">
      <div className="composition-info-wrapper">
        <div className="composition-info-title-div">
          <div className="composition-title-wrapper">
            <h2 className="composition-info-container composition-title" dangerouslySetInnerHTML={{ __html: formatCompositionTitle(Data.pageTitle) }}>
            </h2>
            {/* <img className="info-icon" src={infoIcon} alt="info-icon" /> */}
            {/* <Button baseName="info-btn nds-button--ghost nds-button" ref={setInfoRef}><img className="info-icon" src={infoIcon} alt="info icon" aria-label={`more info`} />
          </Button> */}
          </div>
          <h3 className="composition-info-container composition-subtitle">
            <span dangerouslySetInnerHTML={{ __html: formatCustomText(Data.customText1) }}></span><span dangerouslySetInnerHTML={{ __html: formatCustomText(Data.customText2) }}></span>
          </h3>
        </div>
        <div className="composition-info-img-div">

          <img className={Data.customImage === "https://wwnorton.com/static/assets/images/cover@3x.png" ? "composer-image-unavailable" : "composer-image"}
            // src={image}
            src={Data.customImage}
            alt="composer" />
          {/* <Popover
            title="Title"
            hideTitle={true}
            hideCloseButton={true}
            placement="top"
            reference={infoRef}
            isOpen={infoIsOpen}
            onRequestClose={() => setInfoIsOpen(false)}
            onRequestOpen={() => setInfoIsOpen(true)}
          >
            <p>Performance: {Data.credits}</p>
            <p>Content authors: {Data.authorcredits}</p>
            <div className="close-btn-container">
              <Button variant="ghost" onClick={() => setInfoIsOpen(false)}>Close</Button>
            </div>
          </Popover> */}
        </div>
      </div>
      <AudioPlayer
        audRef={audRef}
        isPlaying={isPlaying}
        setIsPlaying={setIsPlaying}
        setCurrentTime={setCurrentTime}
        currentTime={currentTime}
        dataLoaded={dataLoaded}
        Data={Data}
        timelineIndex={timelineIndex}
        formatSectionHeaderStr={formatSectionHeaderStr}
        updateTime={updateTime}
        formatTime={formatTime}
      />
    </section>
  )
}

export default AudioControlsSection;